import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { UserSession } from '~/data/auth.server'

import Mobile from './Mobile'
import UserMenu from './UserMenu'
import Button from '../Button'
import Modal from '../Modal'

import Logo from '~/icons/logo.svg'
import Location from '~/icons/location.svg'

import { City, CITY_LABELS } from '~/utils'

import 'app/styles/components/Navbar.css'
import LocationModal from '../Modals/LocationModal'

const Navbar = ({ user, city }: { user?: UserSession | null; city?: City }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <>
      <Modal open={modalOpen}>
        <LocationModal city={city} onClose={() => setModalOpen(false)} />
      </Modal>
      <Mobile
        user={user}
        city={city}
        openLocationModal={() => setModalOpen(true)}
      />
      <div className='py-4 px-16 hidden md:flex justify-between'>
        <div className='flex items-center gap-14'>
          <a href='/'>
            <img src={Logo} alt='logo_icon' />
          </a>
          <div className='flex items-center gap-6 body-p-small'>
            <a
              href='/events/search'
              className={pathname === '/events/search' ? 'text-blue' : ''}
            >
              Events
            </a>
            <a
              href='/artists/search'
              className={pathname === '/artists/search' ? 'text-blue' : ''}
            >
              Artists
            </a>
            <a
              href='/hosts/search'
              className={pathname === '/hosts/search' ? 'text-blue' : ''}
            >
              Hosts
            </a>
            {user && (
              <a
                href='/events/feed'
                className={pathname === '/events/feed' ? 'text-blue' : ''}
              >
                My Feed
              </a>
            )}
          </div>
        </div>
        <div className='flex gap-6 items-center'>
          <button
            className='flex gap-2 text-magenta underline items-center'
            onClick={() => setModalOpen(true)}
          >
            <img src={Location} alt='location_icon' />
            {city ? CITY_LABELS[city] : CITY_LABELS.melbourne_australia}
          </button>
          {user ? (
            <UserMenu user={user} />
          ) : (
            <div className='flex gap-3'>
              <Button
                variant='secondary'
                onClick={() => navigate('/auth/login')}
              >
                Log In
              </Button>
              <Button
                variant='primary'
                onClick={() => navigate('/auth/signup')}
              >
                Sign up
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Navbar
